import { FieldCondition } from '../../type';

const evaluateCondition = (
  condition: FieldCondition,
  formattedValues: Record<string, string>,
): boolean => {
  const fieldValue = formattedValues[condition.field] ?? '';

  switch (condition.operator) {
    case 'equals': return fieldValue === condition.value;
    case 'notEquals': return fieldValue !== condition.value;
    case 'contains': return fieldValue.includes(condition.value);
    case 'notContains': return !fieldValue.includes(condition.value);
    default: return false;
  }
};

export const evaluateConditions = (
  conditions: FieldCondition[],
  formattedValues: Record<string, string>,
): boolean => conditions.every((c) => evaluateCondition(c, formattedValues));
